import { useState } from "react";
import IconInfo from "../../../../../../components/icons/icon-info/icon-info";
import IconSettings from "../../../../../../components/icons/icon-settings/icon-settings";
import Icon from "../../../../../../components/icons/icon/icon";
import { BUTTON_VARIANTS } from "../../../../../../components/inputs/button-variants";
import {
    Button,
    IButtonProps,
} from "../../../../../../components/inputs/button/button";
import { DefaultModalLayout } from "../../../../../../components/modal/layouts/default-modal-layout";
import { Tooltip } from "../../../../../../components/tooltip/tooltip";
import "./address-editor-trigger.scss";
import { AddressEditorForm } from "../address-editor-form/address-editor-form";
import FontBody2 from "../../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../../components/fonts/font-props";
import { PolicyAddressRequirementsStore } from "../../../../stores/policy-address-requirements-store";

type AddressEditorTriggerProps = {
    addressRequirements: PolicyAddressRequirementsStore;

};

export const AddressEditorTrigger = ({
    addressRequirements,

}: AddressEditorTriggerProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClose = () => {
        setIsOpen(false);
        addressRequirements.discardChanges();
    };

    const handleSubmit = () => {
        setIsOpen(false);
    };

    const buttons: IButtonProps[] = [
        {
            text: "Cancel",
            variant: BUTTON_VARIANTS.Tertiary,
            onClick: handleClose,
            hasLoader: false,
        },
        {
            text: "Apply",
            variant: BUTTON_VARIANTS.Primary,
            onClick: handleSubmit,
            hasLoader: true,
        },
    ];

    return (
        <>
            <div className="address-editor-trigger--container">
                <div className="address-editor-trigger">
                    <div className="address-editor-trigger--label">
                        <Icon Component={IconSettings} />
                        <FontBody2 color={FONT_COLOR.PRIMARY2}>
                            Customize Address Fields Display & Validation
                        </FontBody2>

                        <Tooltip
                            content={
                                <FontBody2 color={FONT_COLOR.NEUTRAL_1_WHITE}>
                                    Click to configure field visibility and
                                    validation settings for customer address
                                    forms
                                </FontBody2>
                            }
                        >
                            <Icon Component={IconInfo} />
                        </Tooltip>
                    </div>
                    <Button
                        variant={BUTTON_VARIANTS.PrimaryAccent}
                        text="Edit Address"
                        onClick={() => setIsOpen(true)}
                    />
                </div>
            </div>
            {isOpen && (
                <DefaultModalLayout
                    isCloseDisabled={false}
                    onCloseClicked={handleClose}
                    buttons={buttons}
                >
                    <AddressEditorForm
                        addressRequirements={addressRequirements}
                    />
                </DefaultModalLayout>
            )}
        </>
    );
};
